import React from 'react';
import {TextField} from '@material-ui/core';
import {
    OnBlurEvent,
    OnMouseDivEvent,
    OnChangeTextFieldEvent,
    OnKeyboardEvent,
} from '@pluto/@types';

export type TextInputVariant = 'filled' | 'outlined' | 'standard';

export interface TextInputProps {
    value: string;
    autoFocus: boolean;
    multiline?: boolean;
    rowsMax?: number;
    variant?: TextInputVariant;
    onBlur: (event: OnBlurEvent) => void;
    onChange: OnChangeTextFieldEvent;
    onClick: (event: OnMouseDivEvent) => void;
    onKeyPress: (event: OnKeyboardEvent) => void;
}

export default function TextInput(props: TextInputProps) {
    const {
        value,
        autoFocus,
        variant = 'standard',
        multiline = false,
        rowsMax = 1,
        onBlur,
        onChange,
        onClick,
        onKeyPress,
    } = props;
    
    return (
        <TextField
            type="text"
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            onClick={onClick}
            autoFocus={autoFocus}
            onKeyPress={onKeyPress}
            variant={variant}
            multiline={multiline}
            rows={3}
            rowsMax={rowsMax}
            inputProps={
                {
                    maxLength: 254,
                }
            }
        />
    );
}
